import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../colorVars';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import { WarningBody3 } from '../../../atomic/text/Text';
import style from './ApiCallsLeft.module.css';

export const ApiCallsLeft = observer(() => {
  const { apiCallsStore, tradierLoginStore } = useWebsocketStore();
  const callsRemaining = apiCallsStore.callsRemaining;
  const loggedIn = tradierLoginStore.loggedIn ?? null;

  if (loggedIn === false)
    return (
      <div className={style.container}>
        <WarningBody3 color={colors.lightGrey} fontWeight={700}>
          Not Connected to Brokerage
        </WarningBody3>
      </div>
    );
  if ((callsRemaining > 25) | (callsRemaining === 0)) return null;
  return (
    <div className={style.container}>
      <WarningBody3 color={colors.lightGrey} fontWeight={700}>
        Less Than 25 Symbols Remaining
      </WarningBody3>
    </div>
  );
});
